import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { InsightsState, Option } from "lib/types/state"

const initialState: InsightsState = {
  selectedReasons: [],
  selectedPaymentProviders: [],
  numberOfHits: "25"
}

export const slice = createSlice({
  name: "insights",
  initialState: { ...initialState },
  reducers: {
    setSelectedReasons(state, action: PayloadAction<Option[]>) {
      state.selectedReasons = action.payload
    },
    setSelectedPaymentProviders(state, action: PayloadAction<Option[]>) {
      state.selectedPaymentProviders = action.payload
    },
    setNumberOfHits(state, action: PayloadAction<string>) {
      state.numberOfHits = action.payload
    }
  }
})

const { actions, reducer } = slice
export const { setSelectedReasons, setSelectedPaymentProviders, setNumberOfHits } = actions

export default reducer
